<div class="access-control-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <mat-icon>admin_panel_settings</mat-icon>
      </div>
      <div class="header-text">
        <h1>Access Control</h1>
        <p>Manage module-level permissions for each user role</p>
      </div>
    </div>
  </div>

  <!-- Role Selector Card -->
  <div class="role-selector-card">
    <div class="role-selector-row">
      <mat-form-field appearance="outline" class="role-select-field">
        <mat-label>Select User Role</mat-label>
        <mat-select (selectionChange)="onRoleChange()" [(value)]="selectedRole">
          <input class="select-search-input" placeholder="Search roles..." type="text" autocomplete="off" (keyup)="onRoleKey($event)" matInput />
          <mat-option *ngFor="let role of filteredRoles" [value]="role">{{ role.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button *ngIf="showContent" mat-flat-button color="primary" class="save-btn" (click)="save()">
        <mat-icon>save</mat-icon>
        Save Permissions
      </button>
    </div>

    <div class="role-summary" *ngIf="showContent">
      <span class="summary-chip">
        <mat-icon>verified_user</mat-icon>
        {{ modules_selected.length }} of {{ modules.length }} modules enabled
      </span>
    </div>
  </div>

  <!-- Modules Grid -->
  <div class="modules-section" *ngIf="showContent">
    <div class="section-header">
      <h2>Module Permissions</h2>
      <mat-checkbox
        [checked]="allSelected"
        [indeterminate]="someSelected"
        (change)="toggleAll($event)"
        color="primary">
        Toggle All
      </mat-checkbox>
    </div>

    <div class="modules-grid">
      <div *ngFor="let mod of modules" class="module-card" [class.enabled]="isModuleEnabled(mod.name)">
        <div class="module-card-header">
          <div class="module-icon" [class.active]="isModuleEnabled(mod.name)">
            <mat-icon>{{ mod.icon }}</mat-icon>
          </div>
          <mat-slide-toggle
            [checked]="isModuleEnabled(mod.name)"
            (change)="onToggleModule(mod.name, $event)"
            color="primary">
          </mat-slide-toggle>
        </div>
        <div class="module-card-body">
          <h3>{{ mod.displayName }}</h3>
          <p>{{ mod.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!showContent">
    <mat-icon>security</mat-icon>
    <h3>Select a Role</h3>
    <p>Choose a user role above to manage its module permissions</p>
  </div>
</div>